<template>
    <div>
        <b-container>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="[{name: '__slot:Actions', title: 'NAME'}]"
                              :data="SiblingsList"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable"
                              :row-class="onRowClass">
                        <template slot="Actions" scope="props">
                            <span>
                                <b>{{props.rowData.ClientFullName}} </b>
                                <ActionButtonWithIcon v-if="EditMode" :requires-confirmation="true"
                                                      confirmation-string="WARNING: You are about to delete this sibling connection. Are you sure?"
                                                      :endpoint="'Core/ClientSibling/' + props.rowData.Id"
                                                      :payload="{}"
                                                      :perform-global-update="false"
                                                      button-variant="link"
                                                      button-string=""
                                                      button-size="md"
                                                      emit-on-success=""
                                                      v-on:success="GetSiblings"
                                                      icon-prefix="fa"
                                                      icon-suffix="trash-alt"
                                                      icon-color="red"
                                                      method="DELETE" />
                            </span>

                           
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode" class="vert-icons">
                        <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddRecord()" class="pointer olive-green-text" />
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <!--ADD NEW RECORD MODAL-->
        <b-modal ref="add-modal" title="Assign Sibling" hide-footer>
            <b-container>
                <b-form @submit="AssignSiblingSet">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Select a Sibling to Link:</label>
                                <v-select required :options="ClientEnrollmentsList" label="label" :reduce="option => option.Id" v-model="SiblingB">
                                    <template #search="{attributes, events}">
                                        <input class="vs__search"
                                               :required="!SiblingB"
                                               v-bind="attributes"
                                               v-on="events" />
                                    </template>
                                </v-select>
                                <!--<select class="form-control" v-model="SiblingB" required>
                                    <option v-for="option in ClientEnrollmentsList" v-bind:value="option.Id">
                                        {{ option.Client.Person.FullName }}
                                    </option>
                                </select>-->
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelAddRecord()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import ActionButtonWithIcon from '../../Admin/ActionButtonWithIcon.vue';

    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    export default {
        props: [
            'ClientSubProgramMembershipID',
            "EditMode"

        ],
        data: function () {
            return {
                SiblingsList: [],
                SiblingB: "",
            };
        },
        methods: {
            ShowAddRecord() {
                this.SiblingB = "";
                this.$refs["add-modal"].show();
            },
            HideAddRecord() {
                this.$refs["add-modal"].hide();
            },
            GetSiblings() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/ClientSibling", { ClientSubProgramMembershipID: this.ClientSubProgramMembershipID }, this.GetSiblingsSuccess, () => { }, false);

            },
            GetSiblingsSuccess(response) {
                this.SiblingsList = response.data.data;
            },
            DeleteSiblingSet() {
                this.$MasterAPI.ExecuteRequest("DELETE", "Core/ClientSibling/" + this.ChildRecordData.Id, {}, this.GetSiblings(), () => { }, true);

            },
            AssignSiblingSet(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Core/ClientSibling", { SiblingAClientSubProgramMembershipID: this.ClientSubProgramMembershipID, SiblingBClientSubProgramMembershipID: this.SiblingB }, this.GetSiblings, () => { }, true);
                this.$refs["add-modal"].hide();
            },
            UpdateClientLabel() {
                let vm = this;
                this.$store.state.Clients.ClientEnrollmentsList.map(function (client) {
                    if (client.ClientProgramMembership.EndDate != null)
                        return client.label = client.Client.Person.FullName + ' ' + vm.formatDate(client.ClientProgramMembership.StartDate) + ' - ' + vm.formatDate(client.ClientProgramMembership.EndDate);
                    else {
                        return client.label = client.Client.Person.FullName;
                    }
                });
            },
            formatDate(value, fmt = 'MM/DD/YY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        mounted() {
            this.GetSiblings();
        },
        computed: {
            ClientEnrollmentsList: function () {
                this.UpdateClientLabel();
                return this.$store.state.Clients.ClientEnrollmentsList;
            },
        },
        components: {
            Vuetable,
            ActionButtonWithIcon,
            vSelect
        },
    }
</script>

<style scoped>
</style>